/** Canonical public contact details — use across Footer, Contact, FAQ, etc. */
export const COMPANY_CONTACTS = {
  email: "info@sv-city.com.ua",
  phones: [
    { display: "UA +380 50 949 34 82", tel: "+380509493482" },
    { display: "UA +380 50 862 65 40", tel: "+380508626540" },
    { display: "IT +39 320 354 70 71", tel: "+393203547071" },
  ],
  /** Primary support line shown in FAQ / Contact CTAs */
  primaryPhone: "+380 50 862 65 40",
  primaryPhoneTel: "+380508626540",
  telegram: "https://t.me/svcitytrans",
  whatsapp: "https://wa.me/380508626540",
  facebook: "https://www.facebook.com/svcitytrans",
  instagram:
    "https://www.instagram.com/sv_city_trans?igsh=enNvMnhieXplcDRn&utm_source=qr",
};
